import { AppHeaderTheme } from '@app/core/layout/app-header/app-header-theme.model';
import { RouteConfig } from '@app/core/models';
import { CommunicationsHeaderBar } from '../components/communications-header-bar/communications-header-bar.component';
import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserProfileFacade } from '@app/modules/core/store/user-profile';

export const CommunicationsRouteConfigResolver: ResolveFn<RouteConfig> = () => {
  const isSideNavEnabled = inject(UserProfileFacade).sideNavEnabled();
  const contentComponent = isSideNavEnabled ? null : () => CommunicationsHeaderBar;

  return {
    headerConfig: {
      theme: AppHeaderTheme.Default,
      labelKey: 'COMMUNICATIONS.COMMUNICATIONS',
      contentComponent
    }
  };
};
